import {
  hasSMCaptcha,
  initSMCaptcha,
  showSMCaptcha,
  closeSMCaptchaPopup
} from './smcp';
import { getUserInfo, transformRequest } from '../utility';

const baseURL = (window.ISONLINE || window.ISONLINE === undefined) ? window.HTTPUrl.live : window.HTTPUrl.live_test;

const VERIFYCODE = 50804;

// 初始化标志
let initFlag = false;
let verifyCallback;
// callback列表
// const verifyCallbackList = [];
// 执行callback列表
// const doVerifyCallbackList = (state) => {
//   let cb = verifyCallbackList.shift();
//   while (cb) {
//     cb && cb(state);
//     cb = verifyCallbackList.shift();
//   }
// };

const track = (url, act) => {
  window.KEWLSensor.register('kewlweb_url_active', {
    url: '',
    act: -1
  });
  window.KEWLSensor.track('kewlweb_url_active', {
    url,
    act
  });
};

const getConfigParamValueByKey = (config, key) => {
  let value = config.params[key];
  if (typeof config.data === 'string') {
    let splitArr;
    config.data.split('&').some((item) => {
      splitArr = item.split('=');
      if (splitArr[0] === key && splitArr[1]) {
        // eslint-disable-next-line prefer-destructuring
        value = splitArr[1];
        return true;
      }
      return false;
    });
  } else if (Object.prototype.toString.call(config.data) === '[object FormData]') {
    value = config.data.get(key);
  } else if (typeof config.data === 'object') {
    value = config.data[key];
  }
  return value;
};

const showVerify = (url) => {
  url && track(url, 1020);
  showSMCaptcha();
};

const init = (response, scene) => {
  initSMCaptcha({
    options: {},
    callback: (SMCaptcha) => {
      // 验证回调
      SMCaptcha.onSuccess(async (result) => {
        console.log('SMCaptcha', 'onSuccess');
        track(scene, result.pass ? 1021 : 1022);
        // {rid: "2017080810405655b3377d25de478233", pass: false}
        // 这里可以获取前端验证状态,pass为true验证码前端验证成功;pass为false,前端验证失败,需要可以提醒用户
        // 通知服务端验证结果
        const postData = {
          rid: result.rid,
          firstRes: result.pass ? 'PASS' : 'FAILED',
          scene
        };
        // 如果拦截的是登录接口需要传access_token
        if (response.config.url.toLowerCase().indexOf('channel/login') > -1) {
          postData.access_token = getConfigParamValueByKey(response.config, 'access_token');
        }
        try {
          const userInfo = await getUserInfo();
          if (userInfo && (userInfo.userId || userInfo.user.uid)) {
            postData.uid = userInfo.userId || userInfo.user.uid;
          }
        } catch (e) {
          console.log(e);
        }
        window.KEWLHttp.post(`${baseURL}/artemis/v1/risk/recaptcha`, transformRequest(postData)).then((res) => {
          if (res.status == 200 && res.data.status == 200 && res.data.data) {
            const { riskLevel } = res.data.data;

            switch (riskLevel) {
              case 'PASS': // 放行
                verifyCallback(true);
                // doVerifyCallbackList(true);
                break;
              case 'REJECT': // 拒绝
                closeSMCaptchaPopup();
                verifyCallback(false);
                // doVerifyCallbackList(false);
                break;
              case 'REVIEW': // 继续
              case 'VERIFY': // 继续
                break;
              default:
                break;
            }
          // } else if (res.data.status == 40200) {
          // // 数美QPS超限
          //   closeSMCaptchaPopup();
          //  // doVerifyCallbackList(false);
          // } else if (res.data.status == 40201) {
          // // 数美服务失败
          //   closeSMCaptchaPopup();
          //  // doVerifyCallbackList(false);
          // } else if (res.data.status == 40202) {
          // // 参数不合法
          //   closeSMCaptchaPopup();
          //  // doVerifyCallbackList(false);
          // } else if (res.data.status == 40203) {
          // // 风控服务失败
          //   closeSMCaptchaPopup();
          //  // doVerifyCallbackList(false);
          } else {
            closeSMCaptchaPopup();
            verifyCallback(false);
            // doVerifyCallbackList(false);
          }
        }).catch(() => {
          if (result.pass) {
            // 重新显示数美验证码
            showVerify();
          }
        });
      });

      showVerify(scene);
    },
    onClose: () => {
      console.log('SMCaptcha', 'onClose');
      verifyCallback(false);
      // doVerifyCallbackList(false);
    }
  });
};

// 调用数美滑块验证
export const verify = (response, scene, callback) => {
  verifyCallback = callback;
  // verifyCallbackList.push(callback);

  if (hasSMCaptcha()) {
    showVerify(scene);
  } else {
    if (initFlag) {
      return;
    }
    initFlag = true;
    init(response, scene);
  }
};

// 滑块验证锁，只能触发一次tryVerify
let tryVerifyLock = true;
// 尝试调用数美滑块验证
export const tryVerify = response => new Promise((resolve, reject) => {
  const oneSts = response.data && response.data.status;
  const secSts = response.data && response.data.data && response.data.data.status;
  if (tryVerifyLock && [+oneSts, +secSts].includes(VERIFYCODE)) {
    tryVerifyLock = false;
    let scene = response.config.url;
    // 特殊处理，取channel/report转发的真实url
    if (response.config.url.toLowerCase().indexOf('channel/report') > -1) {
      scene = decodeURIComponent(getConfigParamValueByKey(response.config, 'url'));
    }
    verify(response, scene, (state) => {
      tryVerifyLock = true;
      // 滑块验证通过，重新发送业务接口
      if (state) {
        window.KEWLHttp(response.config).then((res) => {
          // 将新的响应返回给业务侧
          resolve(res, { isVerify: true });
        });
      } else {
        // 滑块验证失败或到达上限
        if (response.data.status == 200 && response.data.data.status == VERIFYCODE) {
          response.data.status = `${VERIFYCODE}`;
        }
        reject(response);
      }
    });
  } else {
    // 直接返回response，并告知未触发验证
    resolve(response, { isVerify: false });
  }
});

// 关闭数美滑块验证
export const closeVerify = () => {
  if (hasSMCaptcha()) {
    closeSMCaptchaPopup();
  }
};

window.KEWLVerify = {
  verify,
  tryVerify,
  closeVerify
};
